import { apiRequest } from "./client";

/**
 * Audit & Activity (Sprint 12, Part 92 §92.1):
 * - GET  /api/audit?entityType=&action=&limit=&offset=  (any role)
 * - POST /api/audit/:id/undo                            (Owner/Manager)
 */

export const auditApi = {
  async list({ entityType, action, limit, offset } = {}) {
    const qs = new URLSearchParams();
    if (entityType) qs.set("entityType", entityType);
    if (action) qs.set("action", action);
    if (limit) qs.set("limit", String(limit));
    if (offset) qs.set("offset", String(offset));
    const data = await apiRequest(`/api/audit${qs.toString() ? `?${qs.toString()}` : ""}`);
    return {
      items: data?.items || [],
      total: data?.total ?? 0,
      limit: data?.limit ?? 50,
      offset: data?.offset ?? 0,
    };
  },

  async undo(auditId) {
    return apiRequest(`/api/audit/${auditId}/undo`, { method: "POST" });
  },
};
